// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { productGridCardStyles } from "@steiner/Overrides/Widgets/ProductList/ProductListProductGridCard";
import { color, ellipsis, mergeWithCss, xScreen } from "@steiner/XDL/Utilities";
import { css } from "styled-components";

const imageWrapper = {
    css: css`
        display: flex;
        justify-content: center;
        align-items: center;
        aspect-ratio: 1 / 1;
        width: auto;
    `,
};

productGridCardStyles.productPriceAndActionsStyles = {
    productAvailableStyles: {
        inventoryMessage: {
            css: css`
                display: grid;
                grid-template-columns: auto auto;
                justify-content: flex-start;
                align-content: flex-end;
                align-items: stretch;
            `,
        },
    },
    productPriceStyles: {
        wrapper: {
            css: css`
                display: flex;
                flex-direction: column;
                justify-content: flex-end;
                width: 100%;
                min-height: 44px;
            `,
        },
    },
};

productGridCardStyles.productListImageStyles = {
    wrapper: {
        css: css`
            position: relative;
        `,
    },

    productImage: {
        linkWrappingImage: {
            ...mergeWithCss(imageWrapper, {
                css: css`
                    position: relative;
                    height: 307px;
                    ${xScreen("lte", "md")} {
                        height: 358px;
                    }
                    ${xScreen("lte", "xs")} {
                        height: 328px;
                    }
                `,
            }),
        },
        img: {
            ...mergeWithCss(imageWrapper, {
                css: css`
                    img {
                        max-width: 100%;
                        max-height: 100%;
                        object-fit: contain;
                    }
                `,
            }),
        },
    },
};

productGridCardStyles.productInformationStyles = {
    container: {
        gap: 0,
    },
    attributesGridItem: {
        width: 12,
        css: css`
            padding: 0;
        `,
    },
    descriptionGridItem: {
        css: css`
            display: flex;
            align-items: flex-start;
            min-height: 54px;
        `,
    },
    descriptionStyles: {
        productDetailLink: {
            mergeCss: true,
            typographyProps: {
                css: css`
                    min-height: 54px;
                    ${ellipsis(3)};
                `,
            },
        },
        productDetailDescription: {
            css: css`
                min-height: 54px;
                ${ellipsis(3)};
            `,
        },
    },
};

productGridCardStyles.productListGridContainerStyles = {
    container: {
        css: css`
            max-width: 307px;

            ${xScreen("lte", "md")} {
                max-width: 358px;
                margin: auto;
            }
            ${xScreen("lte", "xs")} {
                max-width: 100%;
            }
            & > .bottom-section {
                justify-content: flex-end;
                padding-top: 0;
            }
        `,
    },
    info: {
        css: css`
            height: auto;
        `,
    },
};
